import {
  runBulk,
  type BulkAction,
} from "@/components/molecules/tables/bulk-actions";
import { useHasRole } from "@/features/clients/hooks/use-has-role";
import { useDeleteService } from "@/features/services/hooks/use-services";
import type { Service } from "@/features/services/types";
import { useTranslation } from "@/features/utils/i18n";
import { TrashIcon } from "@phosphor-icons/react";
import { useMemo } from "react";

export const useServicesBulkActions = (): BulkAction<Service>[] => {
  const { t } = useTranslation("services");
  const isOwner = useHasRole("OWNER");
  const deleteService = useDeleteService();

  return useMemo(() => {
    if (!isOwner) return [];

    return [
      {
        key: "delete",
        label: t("actions.deleteSelected"),
        icon: <TrashIcon className="h-4 w-4" />,
        variant: "destructive",
        confirm: (rows) =>
          t("messages.bulkDeleteConfirm", { count: rows.length }),
        onAction: async (rows) => {
          await runBulk(
            rows,
            (service) => deleteService.mutateAsync(service.id),
            {
              success: (count) => t("messages.bulkDeleteSuccess", { count }),
              error: (count) => t("messages.bulkDeleteError", { count }),
            },
          );
        },
      },
    ];
  }, [isOwner, t, deleteService]);
};
